<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddStory" class="ml-auto">
                    <span class="color-white">
                        add story
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="allStories" style="width: 100%">
                    
                    <el-table-column label="image" prop="imageURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="title En">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar"  >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                        </template>
                    </el-table-column>
                  
                    
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit story"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditStory(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                    <el-table-column label="status" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to change this story status?"
                                @confirm="changeStoryStatus(scope.row)"
                                @cancel="scope.row.active = !scope.row.active "
                            >
                                <template #reference>
                                    <el-switch
                                        v-model="scope.row.active"
                                        class="mb-2"
                                    />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedAllStories(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.stories?.list || []
        },
    },
    data(){
        return{
            allStories:[],
            isAddStory:false,
           
        }
    },
    mounted(){
        
        if (!this.cachedAllStories.length){
            this.getAllStories();
        }else{
           
            this.allStories = this.cachedAllStories;
        }
    },
    
    methods:{
       
        async getAllStories(){
            
            const response = await this.$store.dispatch('getAllStories');
            
          
                this.allStories = response.data;
            
            
        },
    
        async changeStoryStatus(storyData){
            
            let dataToSend = {
                status: storyData.status,
                id:storyData.id
            }
            const response = await this.$store.dispatch('changeStoryStatus',dataToSend);
            if (response.data.status == 1){
                this.getAllStories();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }else{
                const currentStory = this.allStories.find(story => story.id == storyData.id )
                currentStory.status = !currentStory.status
            }
            
        },
       
        async handleAddStory(){
            this.$router.push({
                name:'manage-story',
            })
           
        },
        async handleEditStory(story){
            await this.$store.dispatch('storeCurrentStoryToView',story)
            this.$router.push({
                name:'manage-story',
                params:{
                    id:story.id
                }
            })
        }
    }
}
</script>